// * Given a certain array of N elements, this function returns a new array grouped by items

import { IconEmea, IconLatam, IconNa } from '../../../Resources/Images/ImagesLogo';
import { ROLE, ZONE_ID } from '../../Settings/Constants/Constants';

// * eg. array = [1, 2, 3, 4, 5], items = 2 -> [[1, 2], [3, 4], [5]]
export const groupByItems = (array, items) => {
  const arrayReference = [...array];
  const groupByItems = [];
  while (arrayReference.length > 0) {
    groupByItems.push(arrayReference.splice(0, items));
  }
  return groupByItems;
};

function validFormatXX_XX(string) {
  const regx = /^[a-zA-Z]{2}-[a-zA-Z]{2}$/;
  const isValid = regx.test(string);
  return isValid;
}

function quitarTildes(cadena) {
  const sinTildes = cadena
    .replace(/á/g, 'a')
    .replace(/é/g, 'e')
    .replace(/í/g, 'i')
    .replace(/ó/g, 'o')
    .replace(/ú/g, 'u')
    .replace(/Á/g, 'A')
    .replace(/É/g, 'E')
    .replace(/Í/g, 'I')
    .replace(/Ó/g, 'O')
    .replace(/Ú/g, 'U');
  return sinTildes;
}

export const selectCountryByDefault = ({ listCountries, id, codeZone = null }) => {
  const selectCountry =
    listCountries?.find((country) => {
      if (typeof codeZone === 'string' && codeZone !== '') {
        return (
          quitarTildes(country?.abbreviation_name ?? 'co')?.toLowerCase() === codeZone.toLowerCase()
        );
      } else {
        return parseInt(id) === country?.id;
      }
    }) || listCountries?.find((country) => parseInt(id) === country?.id);

  return selectCountry;
};

//Fuction for select zone
export const getIconZone = (zone) => {
  switch (zone) {
    case ZONE_ID.LATAM:
      return IconLatam;
    case ZONE_ID.EMEA:
      return IconEmea;
    case ZONE_ID.NA:
      return IconNa;
    default:
      return false;
  }
};

//Function for select class by membership
export const getClassMembership = (idMembership) => {
  switch (idMembership) {
    case ROLE.BASIC:
      return 'membership-basic';
    case ROLE.GOLD:
      return 'membership-gold';
    case ROLE.PREMIUM:
      return 'membership-premium';
    default:
      return 'membership-basic';
  }
};

//Function for select background class by membership
export const getBgDiscountMembership = (idMembership) => {
  switch (idMembership) {
    case ROLE.BASIC:
      return 'bg-discount-basic';
    case ROLE.GOLD:
      return 'bg-discount-gold';
    case ROLE.PREMIUM:
      return 'bg-discount-premium';
    default:
      return 'bg-discount-basic';
  }
};
